/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Panel,
  Table,
} from 'react-bootstrap';
import {
  min,
  subDays,
  addDays,
  isAfter,
  isBefore,
  endOfDay,
  startOfDay,
  addMinutes,
  differenceInSeconds,
} from 'date-fns';
import config from 'loracfg';
import deviceActions from 'loraactions/device';
import markActions from 'loraactions/mark';
import DatePicker from 'loracoms/DatePicker';
import DateTimePicker from 'loracoms/DateTimePicker';
import Refresher from 'loracoms/Refresher';
import CollapseToggle from 'loracoms/CollapseToggle';
import RichLabel from 'loracoms/RichLabel';
import InlineSelect from 'loracoms/InlineSelect';
import ShowIf from 'loracoms/ShowIf';
import TablePager from 'loracoms/TablePager';
import PanelToolbar from 'loracoms/PanelToolbar';
import Link from 'loracoms/Link';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  normalizeMac,
} from 'lorautils/IdUtils';
import { compactFormat } from 'lorautils/DateTimeUtils';
import styles from './styles.scss';

const cloudVersion = config.profile === 'cloud';
function defaultFrom() {
  return subDays(new Date(), 7);
}

function defaultTo() {
  return new Date();
}

function isNew(time) {
  return differenceInSeconds(new Date(), time) < 10;
}

function calculateTo(to) {
  return addMinutes(to, 1);
}

const kLimit = 20;
const propTypes = {
  plan: React.PropTypes.object.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  getDeviceData: React.PropTypes.func.isRequired,
  handleMark: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceData: React.PropTypes.object.isRequired,
};

class DeviceData extends React.Component {

  static handleDisableDate(d, from) {
    const before = cloudVersion ? isBefore(d, from) : isBefore(d, addDays(from, -1));
    return isAfter(d, min(addDays(from, 7), new Date())) ||
    before;
  }

  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
      deviceData: props.deviceData,
      from: defaultFrom(),
      to: defaultTo(),
      dir: 'up',
      fields: ['radio'],
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail');
    this.handleChangeDir = this.handleChangeDir.bind(this);
    this.handleToggleFields = this.handleToggleFields.bind(this);
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.handleChangeMark = this.handleChangeMark.bind(this);
  }

  componentWillMount() {
    const { deviceId, getDeviceData } = this.props;
    const {
      dir,
      from = defaultFrom(),
      to = defaultTo(),
    } = this.state;
    getDeviceData(deviceId, {
      limit: kLimit,
      dir,
      start: from.valueOf(),
      end: to.valueOf(),
    });
  }

  componentWillReceiveProps(nextProps) {
    const { plan, deviceData, deviceId } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
    if (!_.isEqual(deviceData, this.props.deviceData)) {
      this.setState({ deviceData });
      const { data: { list = [] } = {}, status } = deviceData;
      if (status === 'success') {
        this.setState({ list });
        if (list.length) {
          const to = _.first(list).$time;
          const from = _.last(list).$time;
          this.props.handleMark({ from, to });
        } else {
          this.props.handleMark({ from: null, to: null });
        }
      }
    }
    if (deviceId !== this.props.deviceId) {
      this.resetRequest(deviceId);
    }
  }

  resetRequest(deviceId) {
    const from = defaultFrom();
    const to = defaultTo();
    this.setState({ from, to, reset: new Date().valueOf() });

    this.props.getDeviceData(deviceId, {
      dir: this.state.dir,
      limit: kLimit,
      start: from.valueOf(),
      end: to.valueOf(),
    });
  }

  handleChangeMark(mark = '') {
    const { deviceId, getDeviceData } = this.props;
    const {
      dir,
      from = defaultFrom(),
      to = defaultTo(),
    } = this.state;

    getDeviceData(deviceId, {
      dir,
      limit: kLimit,
      start: cloudVersion ? startOfDay(from).valueOf() : from.valueOf(),
      end: cloudVersion ? endOfDay(to).valueOf() : calculateTo(to).valueOf(),
      mark,
    });
  }

  handleChangeDir(dir) {
    if (dir === this.state.dir) {
      return;
    }

    this.setState({
      dir,
      reset: Math.random(),
    });

    const { deviceId, getDeviceData } = this.props;
    const {
      from = defaultFrom(),
      to = defaultTo(),
    } = this.state;
    getDeviceData(deviceId, {
      dir,
      limit: kLimit,
      start: cloudVersion ? startOfDay(from).valueOf() : from.valueOf(),
      end: cloudVersion ? endOfDay(to).valueOf() : calculateTo(to).valueOf(),
    });
  }

  handleToggleFields(fields) {
    this.setState({ fields });
  }

  handleChangeFrom(from) {
    let { to } = this.state;
    if (cloudVersion) {
      to = endOfDay(from);
    } else if (from.valueOf() > to.valueOf()) {
      to = from;
    }

    this.setState({
      from,
      to,
      reset: Date.parse(new Date()),
    });
    const { deviceId, getDeviceData } = this.props;
    const { dir } = this.state;
    getDeviceData(deviceId, {
      dir,
      limit: kLimit,
      start: cloudVersion ? startOfDay(from).valueOf() : from.valueOf(),
      end: to.valueOf(),
    });
  }

  handleChangeTo(to) {
    const { from = defaultFrom() } = this.state;
    this.setState({
      to,
      reset: Math.random(),
    });

    const { deviceId, getDeviceData } = this.props;
    const { dir } = this.state;
    getDeviceData(deviceId, {
      dir,
      limit: kLimit,
      start: cloudVersion ? startOfDay(from).valueOf() : from.valueOf(),
      end: cloudVersion ? endOfDay(to).valueOf() : calculateTo(to).valueOf(),
    });
  }

  handleReload() {
    this.setState({ reset: Math.random() });

    const { getDeviceData, deviceId } = this.props;
    const { dir } = this.state;
    let { from, to } = this.state;
    // 刷新时，将时间置为最新时间
    from = defaultFrom();
    to = defaultTo();
    this.setState({ from, to });

    getDeviceData(deviceId, {
      dir,
      limit: kLimit,
      start: cloudVersion ? startOfDay(from).valueOf() : from.valueOf(),
      end: cloudVersion ? endOfDay(to).valueOf() : calculateTo(to).valueOf(),
    });
  }

  renderDirToggle() {
    const { plan, dir } = this.state;
    if (plan.status !== 'success') {
      return <i className="fa fa-spinner fa-spin" />;
    }

    return (
      <InlineSelect
        options={[{
          label: (
            <span>
              <i className="fa fa-long-arrow-up" />
              {this.intlMsg.msg('datadir.up', 'lora')}
            </span>
          ),
          value: 'up',
          active: true,
        }, {
          label: (
            <span>
              <i className="fa fa-long-arrow-down" />
              {this.intlMsg.msg('datadir.down', 'lora')}
            </span>
          ),
          value: 'down',
        }]}
        bsStyle="aisz-primary"
        values={[dir]}
        onChange={selected => this.handleChangeDir(selected[0])}
        disabled={plan.data.tier === 1}
      />
    );
  }

  renderFieldsToggle() {
    const { fields } = this.state;
    return (
      <InlineSelect
        options={[{
          label: (
            <span>
              <i className="fa fa-wifi" />
              <span>
                {this.intlMsg.msg('fieldsgroup.radio')}
              </span>
            </span>
          ),
          value: 'radio',
          active: true,
        }, {
          label: (
            <span>
              <i className="fa fa-envelope" />
              <span>
                {this.intlMsg.msg('fieldsgroup.datamsg')}
              </span>
            </span>
          ),
          value: 'datamsg',
        }]}
        bsStyle="aisz-primary"
        values={fields}
        onChange={selected => this.handleToggleFields(selected)}
        multiple
      />
    );
  }

  render() {
    const { deviceData: { status = '' }, expanded = true } = this.state;

    const header = (
      <div className="clearfix">
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.handleReload}
              reloading={status === 'pending'}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={expanded}
              onChange={(v) => { this.setState({ expanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    const {
      fields,
      collapseDEVEUI,
      deviceData,
      list = [],
      dir,
    } = this.state;
    const showRadioFields = fields.includes('radio');
    const showDataFields = fields.includes('datamsg');

    let mark = '';
    let more = false;
    if (deviceData.status === 'success') {
      mark = deviceData.data.mark;
      more = deviceData.data.more;
    }

    const rows = list.map(d => (
      <tr key={`${d.fcnt}-${d.$time}-${d.gateway}`} className={isNew(d.$time) ? styles.new : ''}>
        <td>{compactFormat(d.$time)}</td>
        <td>
          <Link to={`/gateway/detail/${d.gateway}`}>
            <ShowIf if={collapseDEVEUI}>
              <span>{`...${normalizeMac(d.gateway).substr(-5)}`}</span>
            </ShowIf>
            <ShowIf if={!collapseDEVEUI}>
              <span>{normalizeMac(d.gateway)}</span>
            </ShowIf>
          </Link>
        </td>
        <td>
          <Link to={`/gateway/detail/${d.gateway}`}>
            {d.name}
          </Link>
        </td>
        <ShowIf if={showRadioFields && dir === 'up'}>
          <td> {d.channel} </td>
        </ShowIf>
        <ShowIf if={showRadioFields}>
          <td> {d.frequency / 1000000} </td>
        </ShowIf>
        <ShowIf if={showRadioFields}>
          <td> {`${d.bandwidth} | ${d.coderate}`} </td>
        </ShowIf>
        <ShowIf if={showRadioFields}>
          <td> {d.spreadfactor} </td>
        </ShowIf>
        <ShowIf if={showRadioFields && dir === 'up'}>
          <td>
            {d.lorasnr && Number(d.lorasnr).toFixed(1)}
          </td>
        </ShowIf>
        <ShowIf if={showRadioFields && dir === 'up'}>
          <td> {d.rssi} </td>
        </ShowIf>
        <td>
          <RichLabel
            content={d.mtype}
            translateMap={{
              UnconfirmedDataUp: this.intlMsg.msg('detailview.unconfirmeddataup'),
              UnconfirmedDataDown: this.intlMsg.msg('detailview.unconfirmeddatadown'),
              ConfirmedDataUp: this.intlMsg.msg('detailview.confirmeddataup'),
              ConfirmedDataDown: this.intlMsg.msg('detailview.confirmeddatadown'),
              JoinRequest: this.intlMsg.msg('detailview.joinrequest'),
              JoinAccept: this.intlMsg.msg('detailview.joinaccept'),
              RFU: this.intlMsg.msg('detailview.rfu'),
              Proprietary: this.intlMsg.msg('detailview.proprietary'),
            }}
          />
        </td>
        <td>{d.fcnt}</td>
        <ShowIf if={showDataFields}>
          <td> {d.fport} </td>
        </ShowIf>
        <ShowIf if={showDataFields}>
          <td> {d.fctrl} </td>
        </ShowIf>
        <ShowIf if={showDataFields}>
          <td> {d.fopts} </td>
        </ShowIf>
        <ShowIf if={showDataFields && dir === 'up'}>
          <td> {d.size} </td>
        </ShowIf>
        <ShowIf if={showDataFields}>
          <td> {d.data} </td>
        </ShowIf>
      </tr>
    ));

    const {
      from = defaultFrom(),
      to = defaultTo(),
      reset,
    } = this.state;
    const pickers = cloudVersion ? [
      (<DatePicker
        date={from}
        onSelect={this.handleChangeFrom}
      />),
      (<DatePicker
        date={to}
        onSelect={this.handleChangeTo}
        disabled={d => DeviceData.handleDisableDate(d, from)}
      />),
    ] : [
      (<DateTimePicker
        date={from}
        closeOnSelect={false}
        onSelect={this.handleChangeFrom}
      />),
      (<DateTimePicker
        date={to}
        closeOnSelect={false}
        onSelect={this.handleChangeTo}
        disabled={d => DeviceData.handleDisableDate(d, from)}
      />),
    ];

    const tools = [
      ...pickers,
      this.renderDirToggle(),
      this.renderFieldsToggle(),
    ];

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={expanded}
        onEntered={() => { this.setState({ resize: Math.random() }); }}
      >
        <PanelToolbar tools={tools} />
        <div className={styles.dataTable}>
          <Table className="aisz-table-light" striped hover bordered responsive>
            <thead>
              <tr>
                <th> {this.intlMsg.msg('data.field.time', 'lora')} </th>
                <th>
                  {this.intlMsg.msg('data.field.gateway', 'lora')}
                  {' '}
                  <ShowIf if={collapseDEVEUI}>
                    <Link onClick={() => this.setState({ collapseDEVEUI: false })}>
                      <i className="fa fa-expand" />
                    </Link>
                  </ShowIf>
                  <ShowIf if={!collapseDEVEUI}>
                    <Link onClick={() => this.setState({ collapseDEVEUI: true })}>
                      <i className="fa fa-compress" />
                    </Link>
                  </ShowIf>
                </th>
                <th>{this.intlMsg.msg('data.field.gwname', 'lora')}</th>
                <ShowIf if={showRadioFields && dir === 'up'}>
                  <th>
                    <i className="fa fa-wifi" />{' '}{this.intlMsg.msg('data.field.channel', 'lora')}
                  </th>
                </ShowIf>
                <ShowIf if={showRadioFields}>
                  <th>
                    <i className="fa fa-wifi" />{' '}{this.intlMsg.msg('data.field.frequency', 'lora')}
                  </th>
                </ShowIf>
                <ShowIf if={showRadioFields}>
                  <th>
                    <i className="fa fa-wifi" />{' '}{this.intlMsg.msg('data.field.bandwidth', 'lora')}
                  </th>
                </ShowIf>
                <ShowIf if={showRadioFields}>
                  <th><i className="fa fa-wifi" />{' '}SF</th>
                </ShowIf>
                <ShowIf if={showRadioFields && dir === 'up'}>
                  <th><i className="fa fa-wifi" />{' '}SNR</th>
                </ShowIf>
                <ShowIf if={showRadioFields && dir === 'up'}>
                  <th><i className="fa fa-wifi" />{' '}RSSI</th>
                </ShowIf>
                <th> <i className="fa fa-envelope" />{' '}{this.intlMsg.msg('data.field.msgtype', 'lora')} </th>
                <th> <i className="fa fa-envelope" />{' '}{this.intlMsg.msg('data.field.frameno', 'lora')} </th>
                <ShowIf if={showDataFields}>
                  <th> <i className="fa fa-envelope" />{' '}FPort </th>
                </ShowIf>
                <ShowIf if={showDataFields}>
                  <th> <i className="fa fa-envelope" />{' '}FCtrl </th>
                </ShowIf>
                <ShowIf if={showDataFields}>
                  <th> <i className="fa fa-envelope" />{' '}FOpts </th>
                </ShowIf>
                <ShowIf if={showDataFields && dir === 'up'}>
                  <th>
                    <i className="fa fa-envelope" />{' '}{this.intlMsg.msg('data.field.size', 'lora')}
                  </th>
                </ShowIf>
                <ShowIf if={showDataFields}>
                  <th>
                    <i className="fa fa-envelope" />{' '}{this.intlMsg.msg('data.field.data', 'lora')}
                  </th>
                </ShowIf>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
        </div>
        <div className={styles.pager}>
          <TablePager
            status={status}
            mark={mark}
            more={more}
            onNext={this.handleChangeMark}
            onPrev={this.handleChangeMark}
            reset={reset}
          />
        </div>
      </Panel>
    );
  }
}


DeviceData.propTypes = propTypes;

const mapStateToProps = state => ({
  deviceData: state.device.getDeviceData || {},
  plan: state.billing.plan || {},
});

const mapDispatchToProps = {
  getDeviceData: deviceActions.getDeviceData,
  handleMark: markActions.handleMark,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DeviceData));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceData/index.jsx